import { snakeCase } from 'lodash-es';
import { scrollToEle } from 'src/helpers';
import { ExternalBlog } from 'src/types';
import BlogVideoImage from './BlogVideoImage';
import BlogMedia from './BlogMedia';

const BlogStyleList: React.FC<{ externalBlog: ExternalBlog }> = ({ externalBlog }) => {
  return (
    <div className="js-blog-body">
      {externalBlog.bodyHtml && (
        <div
          className="blog__body"
          dangerouslySetInnerHTML={{ __html: externalBlog.bodyHtml }}
        ></div>
      )}

      {externalBlog.media && (
        <div className="blog__list">
          {externalBlog.media
            .map((media, index) => (
              <div key={index}>
                {media.sectionTitle && (
                  <h2
                    id={`blog-media-${snakeCase(media.sectionTitle)}`}
                    className="tw-text-2xl md:tw-text-4xl tw-font-semibold tw-pt-4 md:tw-pt-5 tw-pb-2 tw-m-0"
                  >
                    {media.sectionTitle}
                  </h2>
                )}

                <div className="blog__list-item">
                  <BlogMedia
                    media={media}
                    index={index}
                  />
                  <BlogVideoImage media={media} />
                </div>
              </div>
            ))}
        </div>
      )}

      {externalBlog.bodyAtTheEndHtml && (
        <>
          <div className="tw-mt-8 md:tw-mt-12 tw-border-t tw-border-grey-lighter"></div>
          <div
            className="blog__body"
            dangerouslySetInnerHTML={{ __html: externalBlog.bodyAtTheEndHtml }}
          ></div>
        </>
      )}
    </div>
  );
};

export default BlogStyleList;
